import './login.scss';

import type { PageProps } from 'keycloakify/login/pages/PageProps';
import { useState } from 'react';

import { i18n as fallbackI18n } from '../i18n';
import type { KcContext } from '../kcContext';
import Template from '../Template';

export default function LoginOtp(
  props: Omit<
    PageProps<Extract<KcContext, { pageId: 'login-otp.ftl' }>, any>,
    'Template' | 'doUseDefaultCss'
  >
) {
  const { kcContext, i18n } = props;

  const { otpLogin, url } = kcContext;
  const { msg } = i18n ?? fallbackI18n;

  const [isSubmitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const disableSubmitButton = () => setSubmitButtonDisabled(true);

  const [selectedCredentialId] = useState<string | undefined>(otpLogin.userOtpCredentials[0]?.id);

  const cancelUrl =
    process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === 'acc'
      ? 'https://next.ggzecademy.nl/'
      : 'https://portaal.ggzecademy.nl';

  return (
    <Template kcContext={kcContext} i18n={i18n} doUseDefaultCss={true} headerNode={msg('doLogIn')}>
      <form
        onSubmit={disableSubmitButton}
        id="kc-otp-login-form"
        className="kcFormClass"
        action={url.loginAction}
        method="post"
      >
        {selectedCredentialId && (
          <input type="hidden" name="selectedCredentialId" value={selectedCredentialId} />
        )}

        {otpLogin.userOtpCredentials.length > 1 && (
          <div className="kcFormGroupClass">
            <div className="kcInputWrapperClass">
              {otpLogin.userOtpCredentials.map(otpCredential => (
                <div key={otpCredential.id} className="kcSelectOTPListClass">
                  <input type="hidden" value="${otpCredential.id}" />
                  <div className="kcSelectOTPListItemClass">
                    <span className="kcAuthenticatorOtpCircleClass" />
                    <h2 className="kcSelectOTPItemHeadingClass">{otpCredential.userLabel}</h2>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        <div className="kcFormGroupClass">
          <div className="kcLabelWrapperClass">
            <h1>Vul code in</h1>
            <label htmlFor="otp" className="kcLabelClass">
              Vul de code in uit de authenticatie-app op je mobiele telefoon of je browser:
            </label>
          </div>

          <div className="kcInputWrapperClass">
            <input
              id="otp"
              name="otp"
              autoComplete="off"
              type="text"
              className="kcInputClass"
              autoFocus
            />
          </div>
        </div>

        <div className="kcFormGroupClass">
          <div id="kc-form-options" className="kcFormOptionsClass">
            <div className="kcFormOptionsWrapperClass" />
          </div>

          <div id="kc-form-buttons" className="kcFormButtonsClass">
            <button
              className={`btn btn-primary ${isSubmitButtonDisabled ? `loading` : ``}`}
              name="login"
              id="kc-login"
              type="submit"
              disabled={isSubmitButtonDisabled}
            >
              Inloggen
            </button>
            <a className="btn btn-tertiary ml-1" href={cancelUrl}>
              Annuleren
            </a>
          </div>
          <p className="privacy-text">
            Meer weten of kom je er niet uit? Lees de{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://support.ggzecademy.nl/support/solutions/articles/23000025621-2-factor-authenticatie-2fa-/ "
            >
              uitgebreide uitleg
            </a>{' '}
            over 2-Factor-Authenticatie op onze support-site.
          </p>
        </div>
      </form>
    </Template>
  );
}
